module.exports = __WEBPACK_EXTERNAL_MODULE_39__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom","umd":"react-dom"}
// module id = 39
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom","umd":"react-dom"}